import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Checkbox, Tooltip } from '@material-ui/core';
import MaterialTable from 'material-table';
import * as S from './styles';
import api from '../../../../services/api';
import moment from 'moment';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import { toast } from 'react-toastify';
import '../../TargetReport/TableContent/index.css';

function TableContent({
    tableData,
    totalTableData,
    scheduleDate,
    selectedItens,
    setSelectedItens,
    setIsLoading
}) {
  const formatterPercent = new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const toCurrency = (e) => {
    return (
      <>
        <span>{e ? formatter.format(e) : '0,00'}</span>
      </>
    );
  };

  const monthlyReport = (ancoraId) => {
    const day = 1
    const month = scheduleDate.getMonth() + 1
    const year = scheduleDate.getFullYear()
    window.location = `/app/relatorios/mensal/${ancoraId}/${day+'-'+month+'-'+year}`;
  }

  const isSelected = (item) => {
    const filteredList = selectedItens.filter(x => x.ancoraId == item.ancoraId)
    return filteredList.length > 0
  }

  const handleSelectSingleRow = (item) => {
    let arrayList = []
    selectedItens.map(x => {
        arrayList.push(x)
    })
    if(isSelected(item)) {
        arrayList = arrayList.filter(x => x.ancoraId !== item.ancoraId)
    } else {
        arrayList.push(item)
    }
    setSelectedItens(arrayList)
  }

  const handleSelectAll = () => {
    let arrayList = []
    if(selectedItens.length < tableData.length) {
        tableData.map(item => {
            arrayList.push(item)
        })
        setSelectedItens(arrayList)
    } else {
        setSelectedItens([])
    }
  }

  const bodyTable = tableData?.map(function (item, index) {
      let backColor = 'white';
      if ((index % 2) === parseInt(localStorage.getItem('startRow'))) {
        backColor = '#EEEEEE';
      }
      return (
        <>
          <TableRow style={{ backgroundColor: backColor, cursor: 'pointer' }}>
            <TableCell align="center" stylçe={{ minWidth: 20 }}>
                <input type="checkbox" checked={isSelected(item)} onChange={() => handleSelectSingleRow(item)}/>
            </TableCell>
            <TableCell align="left" style={{ minWidth: 142 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {item.rede}
            </TableCell>
            <TableCell align="right" style={{ minWidth: 130 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {toCurrency(item.volume)}
            </TableCell>
            <TableCell align="right" style={{ minWidth: 130 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {toCurrency(item.receita)}
            </TableCell>
            <TableCell align="right" style={{ minWidth: 130 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {toCurrency(item.comissionamento)}
            </TableCell>
            <TableCell align="center" style={{ minWidth: 50 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {formatterPercent.format(item.valorCdi / 100)}
            </TableCell>
            <TableCell align="center" style={{ minWidth: 50 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {formatterPercent.format(item.taxa / 100)}
            </TableCell>
            <TableCell align="center" style={{ minWidth: 112 }}
                onClick={() => {
                    monthlyReport(item.ancoraId)
                }}
            >
                {item.dataUltimoEnvio ? moment(item.dataUltimoEnvio).format('DD/MM/YYYY HH:mm') : ''}
            </TableCell>
          </TableRow>
        </>
      );
    });

  return (
    <>
      <div
        className="report-tables"
        style={{ margin: '0px 50px', zIndex: '0', position: 'relative' }}
      >
        <div style={{ margin: '5px auto', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <h3 style={{ textAlign: 'center' }}>Totalizador</h3>
          <Table style={{ margin: '15px', backgroundColor: 'white', width: 'auto'  }}>
            <TableHead style={{ backgroundColor: '#232C63' }}>
                <TableRow>
                    <TableCell
                        style={{ color: 'white', fontWeight: 'bold' }}
                        align="center"
                        colSpan={3}
                    >
                        Totalizador
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130  }} align="center">
                        Volume
                    </TableCell>
                    <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130  }} align="center">
                        Receita
                    </TableCell>
                    <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130 }} align="center">
                        Comissionamento
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow style={{ backgroundColor: '#EEEEEE' }}>
                    <TableCell align="right" style={{ width: 130  }}>{toCurrency(totalTableData.totalizadorVolume)}</TableCell>
                    <TableCell align="right" style={{ width: 130  }}>{toCurrency(totalTableData.totalizadorReceita)}</TableCell>
                    <TableCell align="right" style={{ width: 130  }}>{toCurrency(totalTableData.totalizadorComissionamento)}</TableCell>
                </TableRow>
            </TableBody>
          </Table>
        </div>
        
        <div style={{ overflowX: 'auto' }}>
            <Table style={{ margin: '25px auto', maxWidth: '1700px', width: 'auto' }}>
                <TableHead style={{ backgroundColor: '#232C63' }}>
                    <TableRow>
                        <TableCell
                            style={{ color: 'white', fontWeight: 'bold', cursor: 'pointer', width: 20 }}
                            align="center"
                        >
                           <input type="checkbox" checked={tableData.length == selectedItens.length} onChange={handleSelectAll}/>
                        </TableCell>
                        <TableCell
                            style={{ color: 'white', fontWeight: 'bold', width: 142 }}
                            align="left"
                            width="100px"
                        >
                            Rede
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130 }} align="center">
                            Volume
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130 }} align="center">
                            Receita
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130 }} align="center">
                            Comissionamento
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 70 }} align="center">
                            CDI
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 70 }} align="center">
                            Taxa
                        </TableCell>
                        <TableCell style={{ color: 'white', fontWeight: 'bold', width: 130 }} align="center">
                            Ultimo Envio
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{bodyTable}</TableBody>
            </Table>
        </div>
      </div>
    </>
  );
}

export default TableContent;
